import { render, staticRenderFns } from "./CreateNewCustomer.vue?vue&type=template&id=e33e8452&scoped=true&"
import script from "./CreateNewCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewCustomer.vue?vue&type=style&index=0&id=e33e8452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33e8452",
  null
  
)

export default component.exports